import { LegalLayout } from "@/components/LegalLayout";

const Acceptable = () => (
  <LegalLayout
    title="Acceptable Use Policy"
    description="What you can and can't do on Cash Isle."
    updated="May 13, 2026"
  >
    <p>
      Cash Isle exists for honest hustles. To keep it that way, the following are
      strictly prohibited:
    </p>

    <h2>Illegal activity</h2>
    <ul>
      <li>Money laundering, structuring, or terrorist financing.</li>
      <li>Sanctions evasion or transactions with sanctioned persons or regions.</li>
      <li>Sale of regulated drugs, weapons, stolen goods, counterfeit items.</li>
      <li>Unlicensed gambling, lotteries, or pyramid schemes.</li>
      <li>Sexual services, child exploitation material, or human trafficking.</li>
    </ul>

    <h2>Platform abuse</h2>
    <ul>
      <li>Creating multiple accounts, account farming, or impersonation.</li>
      <li>Fake gigs, fake disputes, false proof of work, collusion to defraud.</li>
      <li>Inflated reviews, ratings manipulation, referral fraud.</li>
      <li>Reverse-engineering, scraping, or automated abuse of the API.</li>
      <li>Phishing, social engineering, or malware distribution.</li>
    </ul>

    <h2>Harassment & safety</h2>
    <ul>
      <li>Threats, hate speech, doxxing, or stalking other users.</li>
      <li>Sharing personal data of others without consent.</li>
      <li>Coercion to send money under duress.</li>
    </ul>

    <h2>Enforcement</h2>
    <p>
      We may freeze wallets, reverse transactions, ban accounts, and report to
      law enforcement. Decisions are at our sole discretion. Repeat or severe
      violations result in permanent ban and possible forfeiture of held funds.
    </p>

    <h2>Reporting</h2>
    <p>
      Report violations to <a href="mailto:trust@cashisle.app">trust@cashisle.app</a>.
      For urgent safety threats contact local authorities first.
    </p>
  </LegalLayout>
);

export default Acceptable;
